import Alpine from 'alpinejs'

const ExportStatus = (params = {}) => ({
  /**
   * Data
   */
  recordId: params.recordId || null,
  statusUrl: params.statusUrl || '',
  status: params.initialStatus || 'pending',
  downloadUrl: null,
  interval: null,

  /**
   * Lifecycle
   */
  init() {
    if (this.shouldPoll()) {
      this.startPolling()
    } else {
      this.fetchStatus()
    }
  },

  /**
   * Computed
   */
  shouldPoll() {
    return this.status === 'pending' || this.status === 'processing'
  },

  /**
   * Actions
   */
  startPolling() {
    this.fetchStatus()

    this.interval = setInterval(() => {
      this.fetchStatus()
    }, 2000)
  },

  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },

  fetchStatus() {
    fetch(this.statusUrl)
      .then(res => res.json())
      .then(data => {
        this.status = data.status
        this.downloadUrl = data.download_url

        if (!this.shouldPoll()) {
          this.stopPolling()
        }
      })
      .catch(() => {
        this.stopPolling()
      })
  }
})

Alpine.data('ExportStatus', ExportStatus)

export default ExportStatus
